import Image from 'next/image'
import { useRouter } from 'next/router'

/* styling */
import styles from './_.module.css'
import Button from '@/atoms/Button/Button'

function ElevateCMP(): JSX.Element {
  const router = useRouter()
  return (
    <section className="max-width-container | grid grid-cols-1 md:grid-cols-2 gap-8 items-center | py-8 lg:py-32">
      <Image
        src="/assets/elevate-generative-ai/images/elevate-cmp.svg"
        alt=""
        width="528"
        height="559"
        className="order-last md:order-first"
      />

      <div>
        <h2 className="font-heading text-4xl lg:text-5xl font-bold capitalize | mb-8">
          We launched the{' '}
          <span className={styles.textGradient1}>
            Dream Content Marketing Platform!
          </span>
        </h2>

        <p className="text-xl | mb-12">
          Pepper Content’s latest innovation for content marketers and
          businesses is now live.
        </p>

        <Button
          onClick={() => router.push(`/contact-us/`)}
          className="btn-primary | text-xl | flex gap-2 | rounded"
        >
          Book a demo
        </Button>
      </div>
    </section>
  )
}

export default ElevateCMP
